import React from "react";
import { useState } from "react";
import LayoutMain from "../../../components/Layout/Main/Main";
import DataShop from "../../../Data/Shop";
import BannerWithButton from "../../../Partials/BannerWithButton";
import ProductDetail from "../../../Partials/ProductDetail";
import ProductItemCollection from "../../../Partials/ProductItem/Collection";

import Section from "../../../Partials/Section";

const PageShopWineGlassPlanter = () => {
  const [text, setText] = useState('')
  const ProductData = DataShop[5];
  const {colors, description, image, images, price, sizes, title} = ProductData;

  const handleOnChange = (event) => {
      setText(event.target.value)
  }
  
  return (
    
      <LayoutMain>
      <Section>
      <ProductDetail colors={colors} desercption={description} handleOnChange={handleOnChange} image={image} images={images} price={price} sizes={sizes} title={title} value={text} />
      </Section>
        <Section>
          <section className="bg-oliva pt-70 pb-70 pt-sm-25 pb-sm-40 position-relative overflow-hidden">
            <div className="bg-dark-oliva our-products-half-bg"></div>
            <div className="container-3">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <h1 className="text-center product-title">Related Products</h1>
                </div>
              </div>
              <div className="row">
               <ProductItemCollection data={DataShop} />
              </div>
            </div>
              <BannerWithButton link='shop' title='Shop All' />
          </section>
        </Section>
      </LayoutMain>
    
  );
}

export default PageShopWineGlassPlanter